import environment from '@/environment'
import httpClient from '../http-client'

export default (receiptId = 'test', region: string): any => {
    if (environment.isProduction || receiptId !== 'test') {
        return httpClient.get(`/platforms/status?receipt=${receiptId}&region=${region}`)
    } else {
        return new Promise(reslove => {
            reslove({ data: { progress: 100 } })
        })
    }
}
